import React, { useState } from "react";
import "./Presentation.css";

interface EnroulerProps {
  title: string;
  children: React.ReactNode;
}

const Enrouler: React.FC<EnroulerProps> = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`enrouler ${open ? "enrouler--open" : ""}`}>
      <button className="enrouler__header" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <span>{title}</span>
        <span className="enrouler__icon">{open ? "−" : "+"}</span>
      </button>
      <div className="enrouler__body">
        <div className="enrouler__inner">{children}</div>
      </div>
    </div>
  );
};

const Presentation: React.FC = () => (
  <section className="presentation">
    <div className="presentation__inner">
      <h2>En savoir plus</h2>
      <div className="presentation__list">
        <Enrouler title="Qu'est-ce que c'est ?">
          Des outils de Rétablissement qui mélangent informations sur la psychiatrie de manière
          vulgarisée, le témoignage de Celeste Favaro, personne rétablie, et des illustrations
          réalisées par ses soins.
        </Enrouler>
        <Enrouler title="Quel est l'objectif ?">
          Chaque outil est porteur d’un témoignage personnel qui invite à l’échange avec le patient 
          et informe aidants ou professionnel.le.s face à la thématique abordée. 
          Par cet échange se crée quelque chose d’unique : la personne exprime sa version, son vécu, 
          sort du jargon médical pour utiliser ses mots et ainsi se recentrer dans son parcours de soin.
        </Enrouler>
        <Enrouler title="Pour qui ?">
          Pour les personnes atteintes d'un trouble psychique, les aidants, les professionnels.
          Quiconque souhaitant se sensibiliser aux sujets de la psychiatrie de manière vulgarisée.
          Déconseillé aux moins de 14 ans.
        </Enrouler>
        <Enrouler title="Comment ça se présente ?">
          Ce sont des livrets de format A5 de 20 pages maximum. Le texte est réparti en petits paragraphes 
          et avec une grande police. Des illustrations réalisées par mes soins accompagnent le texte. 
          Le papier du livret est épais ainsi en cas de tremblement il n’y a pas de risque de déchirure.
        </Enrouler>
        <Enrouler title="Comment les utiliser ?">
          En entretien, en groupe ou en complément d’autres outils comme les directives anticipées. 
          Les outils peuvent enrichir le savoir des professionnel.le.s et des proches.
        </Enrouler>
      </div>
    </div>
  </section>
);

export default Presentation;
